<template>
  <div>
    <b-modal
      id="modal-invoice-act"
      content-class="modal-fullscreen"
      body-class="modal-body-fullscreen"
      size="xl"
      ref="modal_invoice_act"
      title="Акт"
      :ok-only="false"
      :no-fade="true"
      @ok="onOK"
      @cancel="onCancel"
      @close="onCancel"
      ok-title="Сохранить"
      ok-variant="success"
      cancel-title="Отменить"
      button-size="sm"
      no-close-on-esc
      no-close-on-backdrop
      scrollable
    >
      <b-form>
        <b-row cols-lg="4" cols-md="2" cols="1">
          <b-col>
            <b-form-group
              id="group-numb"
              label="Акт №"
              label-for="input-numb"
            >
              <b-form-input
                id="input_numb"
                size="sm"
                autocomplete="off"
                v-model.number="newItem.numb">
              </b-form-input>
            </b-form-group>

          </b-col>
          <b-col>
            <b-form-group
              id="group-date"
              label="Дата"
              label-for="input-date"
            >
              <b-form-input
                id="input-date"
                size="sm"
                type="date"
                v-model.date="newItem.date"/>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="group-contract"
              label="Договор (№ и Дата)"
              label-for="input-contract"
            >
              <b-form-input
                id="input-contract"
                size="sm"
                autocomplete="off"
                v-model="newItem.contract" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="group-town"
              label="Место составления (Город)"
              label-for="input-town"
            >
              <b-form-input
                id="input-town"
                size="sm"
                autocomplete="off"
                v-model="newItem.town" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
          </b-col>
          <b-col>
          </b-col>
          <b-col>
          </b-col>
        </b-row>
      </b-form>

      <!--  Работы  -->
      <b-card no-body>
        <b-card-header>
          <b-row align-v="center">
            <b-col cols="auto" class="mr-auto">
              <h5 class="">Работы</h5>
            </b-col>
            <b-col cols="auto">
              <b-button size="sm" variant="success" @click.stop="onAddWork()">
                <font-awesome-icon icon="plus" class="mr-1"/>
                Добавить
              </b-button>
            </b-col>
          </b-row>
        </b-card-header>

        <b-table
          id="invoice-works"
          ref="invoice-works"
          class="mb-0"
          selectable
          select-mode="single"
          selectedVariant="success"
          striped
          small
          thead-class="top-fixed-thead thead-light"
          table-class="text-small"
          responsive
          show-empty
          :empty-text="$t('message.common.emptyTable')"
          :items="newItem.works"
          :fields="worksFields"
          no-provider-filtering
          no-provider-paging
          no-provider-sorting
        >
          <template #table-busy>
            <div class="text-center text-success my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Загрузка</strong>
            </div>
          </template>

          <template #cell(index)="row">
            {{ row.index + 1 }}
          </template>

          <template #cell(work_type_id)="row">
            <b-form-select
              id="input_work_type"
              size="sm"
              v-model="row.item.work_type_id"
              :options="work_type_catalogs" />
          </template>

          <template #cell(name)="row">
            <b-form-input
              id="input_name"
              size="sm"
              autocomplete="off"
              v-model="row.item.name">
            </b-form-input>
          </template>

          <template #cell(price)="row">
            <b-form-input
              id="input_price"
              size="sm"
              class="widthPrice"
              autocomplete="off"
              v-model.number="row.item.price">
            </b-form-input>
          </template>

          <template #cell(count)="row">
            <b-form-input
              id="input_count"
              size="sm"
              class="widthPrice"
              autocomplete="off"
              v-model.number="row.item.count">
            </b-form-input>
          </template>

          <template #cell(nds)="row">
            {{ row.item.nds }}%
          </template>

          <template #cell(unit)="row">
            <unit-select id="input_unit" ref="unit_select" :initial-unit="row.item.unit_code" is-short v-on:selectUnit="updateUnit($event, row)" />
          </template>

          <template #cell(summa)="row">
            {{priceFormat(row.item.summa)}}
          </template>

          <template #cell(action)="row">
            <b-button size="sm" variant="danger" @click="removeWork(row)">
              <font-awesome-icon icon="trash" />
            </b-button>
          </template>
        </b-table>

        <b-card-footer footer-bg-variant="light">
          <b-row align-h="between" align-v="center">
            <b-col cols="auto" class="mr-auto">
              Всего работ: <b>{{this.newItem.works.length}}</b> |
            </b-col>
            <b-col cols="auto">
              <b-pagination
                id="invoice-works-pagination"
                pills
                :total-rows="this.newItem.works.length"
                :per-page="worksPerPage"
                v-model="worksCurrentPage"/>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import catalogs from "../../network/catalogs";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
  import unitStore from "../../utilites/unitStore";
    import UnitSelect from "../Catalogs/UnitSelect";
    import ExportFile from "./ExportFile";

export default {
  name: "InvoiceAct",
  components: { UnitSelect, ExportFile },
  mixins: [
    catalogs,
    helpers, dateFormatter, unitStore
  ],
  data() {
    return {
      newItem: {
        id: 0,
        numb: 0,
        date: this.formatDate(new Date()),
        contract: '',
        town: '',
        active: true,
        works: [],
        sum: 0
      },
      nds: 0,
      work_type_catalogs: [],
      worksPerPage: 10,
      worksCurrentPage: 1,
      worksFields: [
        {
          key: 'index',
          label: '№',
          class: 'widthIndex',
        },
        {
          key: 'work_type_id',
          label: 'Вид работ',
          class: 'widthCatalog',
        },
        {
          key: 'name',
          label: 'Наименование',
          sortable: true,
        },
        {
          key: 'price',
          label: 'Цена',
          class: 'widthPrice',
        },
        {
          key: 'count',
          label: 'Количество',
          class: 'widthPrice',
        },
        {
          key: 'unit',
          label: 'Ед. изм.',
          class: 'widthPrice',
        },
        {
          key: 'nds',
          label: 'НДС',
          class: 'widthPrice',
        },
        {
          key: 'sum',
          label: 'Сумма',
          class: 'widthPrice',
        },
        {
          key: 'action',
          label: "Действия",
          class: 'widthPrice',
          tdClass: 'align-bottom'
        },
      ],
      completion: null,
    }
  },
  async created() {
    this.work_type_catalogs = await this.getWorkTypeCatalogOptions();
  },
  methods: {
    showModal(act, nds, completion) {
      this.completion = completion;
      this.nds = nds;

      if (act != null) {
        this.newItem = act;
      } else {
        this.newItem = {
          id: 0,
          numb: 0,
          date: this.formatDate(new Date()),
          contract: '',
          town: '',
          active: true,
          works: [],
        }
      }

      this.$refs.modal_invoice_act.show();
    },
    hideModal() {
      this.$refs.modal_invoice_act.hide();
    },
    onOK() {
      this.hideModal();
      if (this.completion != null) {
        this.newItem.sum = this.newItem.works
          .map(obj => obj.sum)
          .reduce((acc, current) => acc + current, 0);

        this.completion(this.newItem);
      }
    },
    onCancel() {

    },
    onAddWork() {
      const index = this.newItem.works.length + 1;
      const work = {
        sort_index: index,
        id: 0,
        work_type_id: null,
        name: '',
        price: null,
        count: null,
        unit_code: '539',
        nds: this.nds,
        sum: null
      };
      this.newItem.works.push(work);
    },
    removeWork(row) {
      this.newItem.works.splice(row.index,1);
    },
    async getWorkTypeCatalogOptions(data) {
      const result = await this.getWorkTypeCatalogs(data);
      const catalogs = result.data ? result.data.items : null;

      return catalogs
        .sort((x, y) => (Number(y.active) - Number(x.active)))
        .map(e => ({ value: e.id, text: e.name, disabled: !e.active }));
    },
    // Единицы измерения
    updateUnit(unit, row) {
      row.item.unit_code = unit.code;
    },
  },
  watch: {
    'newItem.works': {
      handler: function (newValues, _) {
        newValues.forEach(function (tw) {
          tw.sum = tw.count * tw.price;
        }.bind(this));

        this.newItem.summa = this.totalPriceWorks;
      },
      deep: true
    },
  }
}
</script>

<style>
#modal-invoice-act .modal-dialog {
  max-width: 100% !important;
  max-height: 100% !important;
  height: 100% !important;
  margin: 0 !important;
}

.modal-fullscreen {
  max-height: 100% !important;
  height: 100% !important;
}

.modal-body-fullscreen {
  padding-bottom: 0  !important;
}

#footer {
  position: sticky;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Invoices/InvoiceAct.vue